module.exports = function(dispatcher) {
  return function(monogramUGC) {
    dispatcher.dispatch({
      type: 'updateMonogramUGC',
      monogramUGC
    });
  };
};
